import { ProductData } from "@/interfaces/product/product-related";
import { useRef } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import CardProduct from "@/components/cards/Card";
import { IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

interface Props {
  dataSet: ProductData[];
}

const ProductRelated: React.FC<Props> = ({ dataSet }) => {
  const scrollContainer = useRef<HTMLDivElement>(null);

  const handleProductclick = () => {
    // Your click logic
  };

  const handleScroll = (direction: string) => {
    if (scrollContainer.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer.current;
      const scrollAmount = clientWidth;

      if (direction === 'left') {
        scrollContainer.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else if (direction === 'right') {
        if (scrollLeft + clientWidth < scrollWidth - 1) {
          scrollContainer.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      }
    }
  };

  const validProducts = dataSet.filter((item): item is ProductData => item !== null);
  if (validProducts.length === 0) return null;

  return (
    <Grid container spacing={0}>
      <Grid
        xs={12}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          width: '100%',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        <IconButton
          onClick={() => handleScroll('left')}
          disableFocusRipple
          disableRipple
          sx={{
            position: 'absolute',
            top: '50%',
            left: 10,
            transform: 'translateY(-50%)',
            fontSize: { xs: "14px", md: "12px" },
            zIndex: 99,
            bgcolor: "#FFFFFF",
            borderRadius: '4px',
            boxShadow: "0 0 24px hsla(210, 8%, 62%, .2) !important"
          }}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </IconButton>

        <Grid
          container
          ref={scrollContainer}
          wrap="nowrap"
          sx={{
            overflowX: 'auto',
            scrollSnapType: 'x mandatory',
            p: "16px 0",
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          {[...dataSet].sort((a, b) => b.id - a.id).slice(0, 10).map((item, index) => (
            <Grid
              key={item.id}
              // sm={2}
              // lg={2}
              sx={{
                flex: '0 0 auto',
                mr: "12px",
                maxWidth: { xs: '160px', sm: '170px', md: '180px', lg: '200px' },
                width: "100%",
              }}
            >
              <CardProduct
                handleProductClick={handleProductclick}
                item={item}
                index={index}
                itemList=""
              />
            </Grid>
          ))}
        </Grid>

        <IconButton
          onClick={() => handleScroll('right')}
          disableFocusRipple
          disableRipple
          sx={{
            position: 'absolute',
            top: '50%',
            right: 10,
            transform: 'translateY(-50%)',
            fontSize: { xs: "14px", md: "12px" },
            zIndex: 1,
            bgcolor: "#FFFFFF",
            borderRadius: '4px',
            boxShadow: "0 0 24px hsla(210, 8%, 62%, .2) !important"
          }}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default ProductRelated;